import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChange,
} from "@angular/core";
import { Router } from "@angular/router";
import { FilterService } from "app/bundles/requests/shared/services/filter.service";
import { IconService } from "app/bundles/requests/shared/services/icon.service";
import { RequestService } from "app/bundles/requests/shared/services/request.service";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { StorageService } from "app/shared/services/storage.service";
import { Feature } from "../shared/models/feature";
import { IWorkorderOrServiceRequestSummary } from "../shared/models/request";
declare let $: any;

@Component({
  selector: "app-request-alert",
  templateUrl: "./request-alert.component.html",
  styleUrls: ["./request-alert.component.scss"],
})
export class RequestAlertComponent implements AfterViewInit, OnChanges {
  @Input() title: string;
  @Input() showClose = true;
  @Input() enableModal = false;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();
  @Output() showModal = new EventEmitter<string>();
  public requests: IWorkorderOrServiceRequestSummary[] = [];
  modalEl = null;

  constructor(
    private _rootNode: ElementRef,
    private filterService: FilterService,
    private storageService: StorageService,
    private utilService: UtilService,
    private iconService: IconService,
    private router: Router,
    private requestService: RequestService,
  ) {}

  open() {
    this.modalEl.modal("show");
  }

  onClose() {
    this.showModal.emit("false");
    this.storageService.setLastGeoJsonRequest(
      this.storageService.getGeoJsonRequest(),
    );
    this.modalEl.modal("hide");
    this.requestService.getGeojson();
  }

  closeInternal() {
    this.onClose();
  }

  ngAfterViewInit() {
    this.modalEl = $(this._rootNode.nativeElement).find("div.modal");
  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (this.enableModal === true) {
      const features: Feature[] = this.filterService.differenceAlerts(
        this.storageService.getLastGeoJsonRequest(),
        this.storageService.getGeoJsonRequest(),
      );
      this.requests = this.utilService.getRequestsFromGeojson(
        this.utilService.convertFeatureToGeojson(features),
      );
    }
  }

  has(selector) {
    return $(this._rootNode.nativeElement).find(selector).length;
  }
}
